
import React from 'react';
import { Calendar, Filter } from 'lucide-react';
import { VideoFilterOptions } from '@/hooks/useVideoEvents';

interface EmptyStateProps {
  filterOptions?: VideoFilterOptions;
}

const EmptyState: React.FC<EmptyStateProps> = ({ filterOptions }) => {
  // Check if any filters are active
  const hasActiveFilters = () => {
    if (!filterOptions) return false;
    
    return (
      (filterOptions.title && filterOptions.title.trim() !== '') ||
      !!filterOptions.startDate ||
      !!filterOptions.endDate ||
      (filterOptions.statuses && filterOptions.statuses.length > 0) ||
      (filterOptions.contentTypes && filterOptions.contentTypes.length > 0) ||
      !!filterOptions.showNotes
    );
  };

  return (
    <div className="flex flex-col items-center justify-center py-10 text-gray-500">
      <Calendar className="h-12 w-12 mb-3 opacity-30" />
      <p className="text-lg font-medium">Aucune vidéo à afficher</p>
      <p className="text-sm">Sélectionnez un profil ou changez de période</p>
      
      {hasActiveFilters() && (
        <div className="mt-4 flex items-center text-sm">
          <Filter className="h-4 w-4 mr-1" />
          <p>Des filtres sont actifs, essayez de les modifier ou de les supprimer</p>
        </div>
      )}
    </div>
  );
};

export default EmptyState;
